var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"call-or-buy mt-4 d-flex position-relative"},[_c('div',{staticClass:"box-btn-x text-center pt-2"},[_c('div',{class:{
                    'bor-btn' : true,
                    'active'  : _vm.quantity >= 1
                }},[_c('span',{class:{
                            'btn_rdo' : true,
                            'btn_rdo_buy' : _vm.quantity >= 1
                        },on:{"click":function($event){return _vm.select(1)}}},[_c('i',{staticClass:"icon ion-md-cart mr-2"}),_vm._v("Đặt mua")])])]),_c('div',{class:{
                'box-btn-x text-center pt-2' : true,
                'pl-2' : _vm.$detect == 'mobile'
            }},[_c('div',{class:{
                    'bor-btn' : true,
                    'active-call'  : _vm.quantity == 0
                }},[_c('span',{class:{
                        'btn_rdo' : true,
                        'btn_rdo_call' : _vm.quantity == 0
                    },on:{"click":function($event){return _vm.select(0)}}},[_c('i',{staticClass:"icon ion-ios-call mr-2"}),_vm._v("Gọi điện")])])]),_c('label',{class:{
                'mb-0': true,
                'input-on-alue': true,
                'position-absolute' : true,
                'buy-call' : true
            }},[_vm._v("Hiển thị nút")])])
}
var staticRenderFns = []

export { render, staticRenderFns }